import React, { useContext } from "react"
import { Alert, Box, Button, Divider, Grid} from "@mui/material"

import __t from "../../../lib/traduzioni"
import BSSPreventivoContext from "../../../contexts/BSSPreventivoContext"
import { carrelloConErrori } from "../../MenuCarrello"
import { useLocalStorage } from "react-use"
import BSSButton from "../../form/BSSButton"
import { getActives } from "../../../api/pagamenti"
import useSWRImmutable from 'swr/immutable'
import DefaultLoadingComponent from "../../form/DefaultLoadingComponent"
import DefaultErrorComponent from "../../form/DefaultErrorComponent"
import useBSSLogger from "../../../hooks/useBSSLogger"
import Paga from "./pagamenti/Paga"
import Stripe from "./pagamenti/Stripe"
import Paypal from "./pagamenti/Paypal"
import Braintree from "./pagamenti/Braintree"

const {logger} = useBSSLogger();

const PagamentoComp = {
    "PAYPAL": Paga,
    "BONIFICO": Paga,
    "PAGAFINEMESE": Paga,
    "STRIPE": Stripe
}

const FrammentoPagamenti = ({methods, classes, aggiornaPreventivoStorage, onSubmit, clauses, setClauses}) => {

    //const {preventivi} = useContext(BSSPreventivoContext);
    const [carrelloStorage = {preventivi: [], pagamenti: {}, datiFatturazione: {}}, aggiornaCarrelloStorage, rimuoviCarrelloStorage] = useLocalStorage("spedizioniweb2_preventivo_carrello");

    logger.debug("preventivi da storage da frammento pagamenti", preventivi, carrelloStorage);

    const initialData = async () => {
        let resp = [];

        if(carrelloStorage.preventivi !== undefined && 
            Array.isArray(carrelloStorage.preventivi) && 
                carrelloStorage.preventivi.length > 0 
        ){
            resp = await getActives();
        }
        
        return resp;
    }
    
    const {data: modactives, error} = useSWRImmutable(`/api/getActives`, initialData, {
        onErrorRetry: (error, key, config, revalidate) => {
            return
        }
    })
    
    if(!error && !modactives){
        return (<DefaultLoadingComponent />)
    }
    
    if(error){
        logger.debug('errore', error)
        return <DefaultErrorComponent {...{error}} />
    }
    
    /**
     * @type {import("./pagamenti/model/IModalitapagamento").Modalita[]}
     */
    const listaModalita = (modactives ?? []).map(({modalitapagamento, parametri = null, prezzocommissione, totaleConCommissione, totalecarrello, imponibile, iva}) => {
        const {id, codice, nome} = modalitapagamento
        parametri = parametri === null ? undefined : parametri
            .reduce((obj, {codice, nome, valore, tipo}) => {
                obj[codice] = {nome, valore, tipo};
                return obj;
            }, {})
        const metodo = {id, codice, nome, parametri, prezzocommissione, totaleConCommissione, totalecarrello, imponibile, iva}
        logger.debug("metodo pagamento", metodo)
        return metodo;
    })

    const {preventivi} = carrelloStorage; 

    const subProps = {
        preventivi,
        aggiornaPreventivoStorage,
        onSubmit,
        methods,
        clauses,
        setClauses
    }

    const errori = carrelloConErrori(preventivi)

    return (
        <>            
            {/* <pre>{JSON.stringify(preventivi, null, 2)}</pre> */}
            {(errori === true) ? (
                <Grid item xs={12} className={classes.formGroupBox}>
                    <Alert severity={"error"}>
                        {__t("correggicarrelloperprocedere")}
                    </Alert>
                </Grid>
            ): preventivi.length > 0 ? (
                <Grid item xs={12} className={classes.formGroupBox}>
                    {/* <BSSButton methods={methods} type="submit" size="large" style={{padding: "1em", fontSize: "1.5em", fontWeight: "bolder"}} variant="contained" color="primary" fullWidth >
                        {`${__t("pagafinemese")}`}
                    </BSSButton>                     */}

                    {/* <pre>{JSON.stringify(listaModalita, null, 2)}</pre> */}
                    {listaModalita.map((modalita) => {
                        
                        const Comp = PagamentoComp[modalita.codice];

                        return (
                            <Box py={2}>
                                <Comp key={modalita.id} parametri={modalita.parametri} modalita={modalita} methods={methods} />
                            </Box>
                        )
                    })}

                    <Box py={2}>
                        <Braintree parametri={{}} />
                    </Box>
                </Grid>
            ) : ""}

            
        </>
    )
}

export default FrammentoPagamenti